import React, { useRef, useCallback, useEffect, useState } from 'react';
import './modal.css';
import { useTranslation } from 'react-i18next'
import "swiper/scss";
import "swiper/scss/autoplay";
import "swiper/scss/pagination";
import "swiper/scss/navigation";
import "swiper/scss/virtual";
import ModalAlert from "../modal2026/modalAlert";

const Modal = ({ isOpen, closeModal, variable1, variable2, variable3, id_idea }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const sliderRef = useRef(null);

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [shareOpen, setShareOpen] = useState(false);
  const shareRef = useRef(null);
  const triggerRef = useRef(null);
  const [t, i18n] = useTranslation("detail_blog");
  const shareUrl = "https://www.ricardosalinas.com/es/Ideas-en-Corto?idea=" + id_idea;
  const shareTitle = variable3;

  useEffect(() => {

    const handleClickOutside = (event) => {

      if (
        shareRef.current &&
        !shareRef.current.contains(event.target)
      ) {
        setShareOpen(false);
      }

    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };

  }, []);

  const shareToX = () => {
    window.open(
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareTitle)}`,
      "_blank"
    );
  };

  const shareToFacebook = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
      "_blank"
    );
  };

  const shareToLinkedin = () => {
    window.open(
      `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,
      "_blank"
    );
  };

  const shareByEmail = () => {
    window.location.href =
      `mailto:?subject=${encodeURIComponent(shareTitle)}&body=${encodeURIComponent(shareUrl)}`;
  };

  const copyLink = async () => {

    try {

      await navigator.clipboard.writeText(shareUrl);

      setAlertMessage(
        i18n.language === "en"
          ? "Link copied successfully"
          : "Liga copiada correctamente"
      );

      setAlertOpen(true);

    } catch (err) {

      console.error(err);

      setAlertMessage(
        i18n.language === "en"
          ? "Could not copy the link"
          : "No se pudo copiar la liga"
      );

      setAlertOpen(true);

    }

  };


  const handleNext = () => {
    setCurrentIndex((prev) =>
      prev === images.length - 1 ? 0 : prev + 1
    );
  };

  const handlePrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  const goToImage = (index) => {
    setCurrentIndex(index);
  };

  const [images, setImages] = useState([]);
  const [liga, setLiga] = useState();
  const [btn, setBtn] = useState(
    ``
  );

  const handleX = () => {
    window.open(
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        "https://www.ricardosalinas.com/es/Ideas-en-Corto?idea=" + id_idea
      )}&text=${encodeURIComponent("Idea en corto")}`,
      "_blank"
    );
  };

  const handleFacebook = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent("https://www.ricardosalinas.com/es/Ideas-en-Corto?idea=" + id_idea)}`,
      "_blank"
    );
  };

  const handleLinkedIn = (e) => {
    window.open(
      `https://www.linkedin.com/shareArticle?url=${encodeURIComponent(
        "https://www.ricardosalinas.com/es/Ideas-en-Corto?idea=" + id_idea
      )}&title=${encodeURIComponent("Idea en corto")}`,
      "_blank"
    );
  };

  const handleMail = () => {
    window.location.href = `mailto:?subject=${encodeURIComponent(
      "Idea en corto"
    )}&body=${encodeURIComponent("https://www.ricardosalinas.com/es/Ideas-en-Corto?idea=" + id_idea)}`;
  };

  const handleCopiarURL = () => {
    navigator.clipboard.writeText("https://www.ricardosalinas.com/es/Ideas-en-Corto?idea=" + id_idea).then(() => {
      alert('¡Enlace copiado al portapapeles!');
    }).catch((error) => {
      console.error('Error al copiar al portapapeles:', error);
    });
  };

  useEffect(() => {
    if (!isOpen) return;

    try {
      const imageUrls = variable1.match(/src="([^"]+)"/g).map((src) => src.match(/"([^"]+)"/)[1]);
      setImages(imageUrls)
    } catch (e) {
      if (variable2 === 'video') {
        console.log("Es video");
        const dummyImages = ['dummy1.jpg', 'dummy2.jpg', 'dummy3.jpg'];
        setImages(dummyImages);
      }
    };



    try {
      const ligaUrls = variable1.match(/href="([^"]+)"/g).map((src) => src.match(/"([^"]+)"/)[1]);
      setBtn(`<a class='btn-idea-blog-a' href='` + ligaUrls + `' >Leer blog</a>`);

    } catch (e) {
      console.log("sin liga")
    };



  }, [isOpen]);


  if (!isOpen) return null;

  if (variable2 === 'carrete') {
    const hrefMatch = variable1.match(/href="([^"]*)"/);

    const blogUrl = hrefMatch
      ? hrefMatch[1]
      : "";

    return (
      <>
        <div class="_ngcontent-ng-c485834739 _nghost-ng-c1521374634">
          <div role="dialog" className="reflexion-image-modal">
            <section className="reflexion-image-modal__panel">

              <button
                type="button"
                className="reflexion-image-modal__close"
                onClick={closeModal}
              >
                ×
              </button>

              <div className="reflexion-image-modal__copy">
                <header class="reflexion-image-modal__header">
                  <h2 _ngcontent-ng-c1521374634="" id="reflexion-image-modal-title" class="reflexion-image-modal__title"> {variable3} </h2>
                </header>
                <div className="reflexion-image-modal__body">
                  <div className="reflexion-image-modal__media">

                    {images.length === 0 ? (
                      <>
                        <div className="reflexion-image-modal__image skeleton-carousel-image" />

                        <div className="reflexion-image-modal__progress">
                          {[1, 2, 3, 4].map((item) => (
                            <div
                              key={item}
                              className="reflexion-image-modal__progress-segment skeleton-progress"
                            />
                          ))}
                        </div>
                      </>
                    ) : (
                      <>
                        {/* PREV */}
                        <button
                          type="button"
                          className="reflexion-image-modal__nav reflexion-image-modal__nav--previous"
                          onClick={handlePrev}
                        >
                          ‹
                        </button>

                        <img
                          className="reflexion-image-modal__image"
                          src={images[currentIndex]}
                          alt={`Imagen ${currentIndex + 1}`}
                        />

                        {/* NEXT */}
                        <button
                          type="button"
                          className="reflexion-image-modal__nav reflexion-image-modal__nav--next"
                          onClick={handleNext}
                        >
                          ›
                        </button>

                        <div className="reflexion-image-modal__progress">
                          {images.map((_, index) => (
                            <button
                              key={index}
                              type="button"
                              onClick={() => goToImage(index)}
                              className={`reflexion-image-modal__progress-segment ${index === currentIndex
                                ? "reflexion-image-modal__progress-segment--active"
                                : ""
                                }`}
                              aria-pressed={index === currentIndex}
                            />
                          ))}
                        </div>
                      </>
                    )}

                  </div>
                </div>

                <div className='div-compartir-idea-v'>

                  {/* SHARE */}

                  <span class="click-tooltip">
                    <span
                      tabIndex="0"
                      role="button"
                      className="click-tooltip__trigger"
                      aria-expanded={shareOpen}
                      ref={triggerRef}
                      onClick={() => setShareOpen(prev => !prev)}
                    >
                      <div class="post-actions__group post-actions__group--share library-btn-share">
                        <img
                          src="/assets/img2026/icon_share.svg"
                          alt="Compartir en redes"
                          aria-hidden="true"
                          class="post-actions__icon post-actions__icon--share"
                        />

                        <span class="post-actions__share-link">
                          {(t('2026.compartir'))}
                        </span>
                      </div>
                    </span>

                    {shareOpen && (
                      <span
                        className="click-tooltip__panel"
                        onClick={(e) => e.stopPropagation()}
                        ref={shareRef}
                      >
                        <span role="tooltip" class="up-arrow click-tooltip__content">
                          <span class="click-tooltip__actions">
                            <button
                              type="button"
                              aria-label="Compartir en X"
                              className="click-tooltip__action"
                              onClick={shareToX}
                            >
                              <img
                                src="/assets/img2026/logo_twitter.svg"
                                alt="Compartir en X"
                                className="click-tooltip__icon click-tooltip__icon--x"
                              />
                            </button>
                            <button
                              type="button"
                              aria-label="Compartir en Facebook"
                              className="click-tooltip__action"
                              onClick={shareToFacebook}
                            >
                              <img src="/assets/img2026/logo_facebook.svg" alt="Compartir en Facebook" class="click-tooltip__icon click-tooltip__icon--facebook" />
                            </button>
                            <button
                              type="button"
                              aria-label="Compartir por email"
                              className="click-tooltip__action"
                              onClick={shareByEmail}
                            >
                              <img src="/assets/img2026/icon_email.svg" alt="Compartir por email" aria-hidden="true" class="click-tooltip__icon click-tooltip__icon--email" />
                            </button>
                            <button
                              type="button"
                              aria-label="Compartir en Linkeding"
                              className="click-tooltip__action"
                              onClick={shareToLinkedin}
                            >
                              <img src="/assets/img2026/linkedin.svg" alt="Compartir en LinkedIn" class="click-tooltip__icon click-tooltip__icon--linkedin" />
                            </button>
                            <button
                              type="button"
                              aria-label="Copiar liga"
                              className="click-tooltip__action"
                              onClick={copyLink}
                            >
                              <img src="/assets/img2026/share.svg" alt="Copiar enlace" class="click-tooltip__icon click-tooltip__icon--share" />
                            </button>
                          </span>
                        </span>
                      </span>
                    )}

                  </span>

                  {/* BOTON BLOG */}

                  {blogUrl && (
                    <a
                      href={blogUrl}
                      className='btn_blog_id'
                    >
                      Blog
                    </a>
                  )}

                </div>
              </div>
            </section>
          </div>
        </div>
        <ModalAlert
            isOpen={alertOpen}
            closeModal={() => setAlertOpen(false)}
            variable1={alertMessage}
          />
      </>
    );
  } else {
    if (variable2 === 'imagen') {
      return (
        <>
          <div class="_ngcontent-ng-c485834739 _nghost-ng-c1521374634">
            <div role="dialog" className="reflexion-image-modal">

              <section className="reflexion-image-modal__panel reflexion-image-modal__panel_img">

                <button
                  type="button"
                  className="reflexion-image-modal__close"
                  onClick={closeModal}
                >
                  ×
                </button>

                <header className="video-modal__header">
                </header>

                <div className="video-modal__body">
                  <div className="video-modal__content">

                    <img
                      src={variable1}
                      alt={variable3}
                      className="video-modal__image"
                    />

                  </div>
                </div>
                <div className='div-compartir-idea-v'>

                  {/* SHARE */}

                  <span class="click-tooltip">
                    <span
                      tabIndex="0"
                      role="button"
                      className="click-tooltip__trigger"
                      aria-expanded={shareOpen}
                      ref={triggerRef}
                      onClick={() => setShareOpen(prev => !prev)}
                    >
                      <div class="post-actions__group post-actions__group--share library-btn-share">
                        <img
                          src="/assets/img2026/icon_share.svg"
                          alt="Compartir en redes"
                          aria-hidden="true"
                          class="post-actions__icon post-actions__icon--share"
                        />

                        <span class="post-actions__share-link">
                          {(t('2026.compartir'))}
                        </span>
                      </div>
                    </span>

                    {shareOpen && (
                      <span
                        className="click-tooltip__panel"
                        onClick={(e) => e.stopPropagation()}
                        ref={shareRef}
                      >
                        <span role="tooltip" class="up-arrow click-tooltip__content">
                          <span class="click-tooltip__actions">
                            <button
                              type="button"
                              aria-label="Compartir en X"
                              className="click-tooltip__action"
                              onClick={shareToX}
                            >
                              <img
                                src="/assets/img2026/logo_twitter.svg"
                                alt="Compartir en X"
                                className="click-tooltip__icon click-tooltip__icon--x"
                              />
                            </button>
                            <button
                              type="button"
                              aria-label="Compartir en Facebook"
                              className="click-tooltip__action"
                              onClick={shareToFacebook}
                            >
                              <img src="/assets/img2026/logo_facebook.svg" alt="Compartir en Facebook" class="click-tooltip__icon click-tooltip__icon--facebook" />
                            </button>
                            <button
                              type="button"
                              aria-label="Compartir por email"
                              className="click-tooltip__action"
                              onClick={shareByEmail}
                            >
                              <img src="/assets/img2026/icon_email.svg" alt="Compartir por email" aria-hidden="true" class="click-tooltip__icon click-tooltip__icon--email" />
                            </button>
                            <button
                              type="button"
                              aria-label="Compartir en Linkeding"
                              className="click-tooltip__action"
                              onClick={shareToLinkedin}
                            >
                              <img src="/assets/img2026/linkedin.svg" alt="Compartir en LinkedIn" class="click-tooltip__icon click-tooltip__icon--linkedin" />
                            </button>
                            <button
                              type="button"
                              aria-label="Copiar liga"
                              className="click-tooltip__action"
                              onClick={copyLink}
                            >
                              <img src="/assets/img2026/share.svg" alt="Copiar enlace" class="click-tooltip__icon click-tooltip__icon--share" />
                            </button>
                          </span>
                        </span>
                      </span>
                    )}

                  </span>

                </div>

              </section>
            </div>
          </div>
          <ModalAlert
            isOpen={alertOpen}
            closeModal={() => setAlertOpen(false)}
            variable1={alertMessage}
          />
        </>
      );
    }
    else if (variable2 === 'texto') {
      return (
        <>
          <div class="_ngcontent-ng-c485834739 _nghost-ng-c1521374634">
            <div role="dialog" className="reflexion-image-modal">

              <section className="reflexion-image-modal__panel reflexion-text-modal__panel">

                <button
                  type="button"
                  className="reflexion-image-modal__close"
                  onClick={closeModal}
                >
                  ×
                </button>

                <header className="video-modal__header">
                  <h2 id="video-modal-title" class="video-modal__title">{variable3}</h2>
                </header>

                <div className="video-modal__body">
                  <div className="video-modal__content" dangerouslySetInnerHTML={{ __html: variable1 }}>

                  </div>
                </div>
                <div className='div-compartir-idea-v'>

                  {/* SHARE */}

                  <span class="click-tooltip">
                    <span
                      tabIndex="0"
                      role="button"
                      className="click-tooltip__trigger"
                      aria-expanded={shareOpen}
                      ref={triggerRef}
                      onClick={() => setShareOpen(prev => !prev)}
                    >
                      <div class="post-actions__group post-actions__group--share library-btn-share">
                        <img
                          src="/assets/img2026/icon_share.svg"
                          alt="Compartir en redes"
                          aria-hidden="true"
                          class="post-actions__icon post-actions__icon--share"
                        />

                        <span class="post-actions__share-link">
                          {(t('2026.compartir'))}
                        </span>
                      </div>
                    </span>

                    {shareOpen && (
                      <span
                        className="click-tooltip__panel"
                        onClick={(e) => e.stopPropagation()}
                        ref={shareRef}
                      >
                        <span role="tooltip" class="up-arrow click-tooltip__content">
                          <span class="click-tooltip__actions">
                            <button
                              type="button"
                              aria-label="Compartir en X"
                              className="click-tooltip__action"
                              onClick={shareToX}
                            >
                              <img
                                src="/assets/img2026/logo_twitter.svg"
                                alt="Compartir en X"
                                className="click-tooltip__icon click-tooltip__icon--x"
                              />
                            </button>
                            <button
                              type="button"
                              aria-label="Compartir en Facebook"
                              className="click-tooltip__action"
                              onClick={shareToFacebook}
                            >
                              <img src="/assets/img2026/logo_facebook.svg" alt="Compartir en Facebook" class="click-tooltip__icon click-tooltip__icon--facebook" />
                            </button>
                            <button
                              type="button"
                              aria-label="Compartir por email"
                              className="click-tooltip__action"
                              onClick={shareByEmail}
                            >
                              <img src="/assets/img2026/icon_email.svg" alt="Compartir por email" aria-hidden="true" class="click-tooltip__icon click-tooltip__icon--email" />
                            </button>
                            <button
                              type="button"
                              aria-label="Compartir en Linkeding"
                              className="click-tooltip__action"
                              onClick={shareToLinkedin}
                            >
                              <img src="/assets/img2026/linkedin.svg" alt="Compartir en LinkedIn" class="click-tooltip__icon click-tooltip__icon--linkedin" />
                            </button>
                            <button
                              type="button"
                              aria-label="Copiar liga"
                              className="click-tooltip__action"
                              onClick={copyLink}
                            >
                              <img src="/assets/img2026/share.svg" alt="Copiar enlace" class="click-tooltip__icon click-tooltip__icon--share" />
                            </button>
                          </span>
                        </span>
                      </span>
                    )}

                  </span>

                </div>

              </section>
            </div>
          </div>
          <ModalAlert
            isOpen={alertOpen}
            closeModal={() => setAlertOpen(false)}
            variable1={alertMessage}
          />
        </>
      );
    }
    else if (variable2 === 'video') {
      return (
        <>
          <div className="_ngcontent-ng-c485834739 _nghost-ng-c798911410">
            <div role="dialog" aria-modal="true" aria-labelledby="video-modal-title" class="video-modal">
              <section class="video-modal__panel">
                <button type="button" aria-label="Cerrar video" onClick={() => {
                  closeModal();
                }} class="video-modal__close"> ✕ </button>
                <header class="video-modal__header">
                  <h2 id="video-modal-title" class="video-modal__title">{variable3}</h2>
                </header>
                <div class="video-modal__body" >
                  <div class="video-modal__content">
                    <div class="video-modal__player-frame">
                      <video controls="true" autoplay playsinline="" preload="metadata" class="video-modal__player">
                        <source src={variable1} type="video/mp4" />
                      </video>
                    </div>
                  </div>
                </div>
                <div className='div-compartir-idea-v'>

                  {/* SHARE */}

                  <span class="click-tooltip">
                    <span
                      tabIndex="0"
                      role="button"
                      className="click-tooltip__trigger"
                      aria-expanded={shareOpen}
                      ref={triggerRef}
                      onClick={() => setShareOpen(prev => !prev)}
                    >
                      <div class="post-actions__group post-actions__group--share library-btn-share">
                        <img
                          src="/assets/img2026/icon_share.svg"
                          alt="Compartir en redes"
                          aria-hidden="true"
                          class="post-actions__icon post-actions__icon--share"
                        />

                        <span class="post-actions__share-link">
                          {(t('2026.compartir'))}
                        </span>
                      </div>
                    </span>

                    {shareOpen && (
                      <span
                        className="click-tooltip__panel"
                        onClick={(e) => e.stopPropagation()}
                        ref={shareRef}
                      >
                        <span role="tooltip" class="up-arrow click-tooltip__content">
                          <span class="click-tooltip__actions">
                            <button
                              type="button"
                              aria-label="Compartir en X"
                              className="click-tooltip__action"
                              onClick={shareToX}
                            >
                              <img
                                src="/assets/img2026/logo_twitter.svg"
                                alt="Compartir en X"
                                className="click-tooltip__icon click-tooltip__icon--x"
                              />
                            </button>
                            <button
                              type="button"
                              aria-label="Compartir en Facebook"
                              className="click-tooltip__action"
                              onClick={shareToFacebook}
                            >
                              <img src="/assets/img2026/logo_facebook.svg" alt="Compartir en Facebook" class="click-tooltip__icon click-tooltip__icon--facebook" />
                            </button>
                            <button
                              type="button"
                              aria-label="Compartir por email"
                              className="click-tooltip__action"
                              onClick={shareByEmail}
                            >
                              <img src="/assets/img2026/icon_email.svg" alt="Compartir por email" aria-hidden="true" class="click-tooltip__icon click-tooltip__icon--email" />
                            </button>
                            <button
                              type="button"
                              aria-label="Compartir en Linkeding"
                              className="click-tooltip__action"
                              onClick={shareToLinkedin}
                            >
                              <img src="/assets/img2026/linkedin.svg" alt="Compartir en LinkedIn" class="click-tooltip__icon click-tooltip__icon--linkedin" />
                            </button>
                            <button
                              type="button"
                              aria-label="Copiar liga"
                              className="click-tooltip__action"
                              onClick={copyLink}
                            >
                              <img src="/assets/img2026/share.svg" alt="Copiar enlace" class="click-tooltip__icon click-tooltip__icon--share" />
                            </button>
                          </span>
                        </span>
                      </span>
                    )}

                  </span>

                </div>
              </section>
            </div>
          </div>
          <ModalAlert
            isOpen={alertOpen}
            closeModal={() => setAlertOpen(false)}
            variable1={alertMessage}
          />
        </>
      );
    }
    else if (variable2 === 'texto-imagen') {
      variable1 = variable1.replace('leer entrada', 'Leer blog');

      // EXTRAER href
      const hrefMatch = variable1.match(
        /href="(?!#carouselExampleIndicators)([^"]*)"/
      );

      const blogUrl = hrefMatch
        ? hrefMatch[1]
        : "";

      // LIMPIAR styles y links originales
      let cleanHtml = variable1
        .replace(/style="[^"]*"/g, "")
        .replace(
          /<a(?![^>]*href="#carouselExampleIndicators")[^>]*>.*?<\/a>/gis,
          ""
        );
      return (
        <>
          <div className="_ngcontent-ng-c485834739 _nghost-ng-c798911410">
            <div role="dialog" aria-modal="true" aria-labelledby="video-modal-title" class="video-modal">
              <section class="video-modal__panel video-modal__panel_auto">
                <button type="button" aria-label="Cerrar video" onClick={() => {
                  closeModal();
                }} class="video-modal__close"> ✕ </button>
                <header class="video-modal__header">
                  <h2 id="video-modal-title" class="video-modal__title">{variable3}</h2>
                </header>
                <div class="video-modal__body" dangerouslySetInnerHTML={{ __html: cleanHtml }} >

                </div>
                <div className='div-compartir-idea-v'>

                  {/* SHARE */}

                  <span class="click-tooltip">
                    <span
                      tabIndex="0"
                      role="button"
                      className="click-tooltip__trigger"
                      aria-expanded={shareOpen}
                      ref={triggerRef}
                      onClick={() => setShareOpen(prev => !prev)}
                    >
                      <div class="post-actions__group post-actions__group--share library-btn-share">
                        <img
                          src="/assets/img2026/icon_share.svg"
                          alt="Compartir en redes"
                          aria-hidden="true"
                          class="post-actions__icon post-actions__icon--share"
                        />

                        <span class="post-actions__share-link">
                          {(t('2026.compartir'))}
                        </span>
                      </div>
                    </span>

                    {shareOpen && (
                      <span
                        className="click-tooltip__panel"
                        onClick={(e) => e.stopPropagation()}
                        ref={shareRef}
                      >
                        <span role="tooltip" class="up-arrow click-tooltip__content">
                          <span class="click-tooltip__actions">
                            <button
                              type="button"
                              aria-label="Compartir en X"
                              className="click-tooltip__action"
                              onClick={shareToX}
                            >
                              <img
                                src="/assets/img2026/logo_twitter.svg"
                                alt="Compartir en X"
                                className="click-tooltip__icon click-tooltip__icon--x"
                              />
                            </button>
                            <button
                              type="button"
                              aria-label="Compartir en Facebook"
                              className="click-tooltip__action"
                              onClick={shareToFacebook}
                            >
                              <img src="/assets/img2026/logo_facebook.svg" alt="Compartir en Facebook" class="click-tooltip__icon click-tooltip__icon--facebook" />
                            </button>
                            <button
                              type="button"
                              aria-label="Compartir por email"
                              className="click-tooltip__action"
                              onClick={shareByEmail}
                            >
                              <img src="/assets/img2026/icon_email.svg" alt="Compartir por email" aria-hidden="true" class="click-tooltip__icon click-tooltip__icon--email" />
                            </button>
                            <button
                              type="button"
                              aria-label="Compartir en Linkeding"
                              className="click-tooltip__action"
                              onClick={shareToLinkedin}
                            >
                              <img src="/assets/img2026/linkedin.svg" alt="Compartir en LinkedIn" class="click-tooltip__icon click-tooltip__icon--linkedin" />
                            </button>
                            <button
                              type="button"
                              aria-label="Copiar liga"
                              className="click-tooltip__action"
                              onClick={copyLink}
                            >
                              <img src="/assets/img2026/share.svg" alt="Copiar enlace" class="click-tooltip__icon click-tooltip__icon--share" />
                            </button>
                          </span>
                        </span>
                      </span>
                    )}

                  </span>

                  {/* BOTON BLOG */}

                  {blogUrl && (
                    <a
                      href={blogUrl}
                      className='btn_blog_id'
                    >
                      Blog
                    </a>
                  )}

                </div>
              </section>
            </div>
          </div>
          <ModalAlert
            isOpen={alertOpen}
            closeModal={() => setAlertOpen(false)}
            variable1={alertMessage}
          />
        </>
      );
    }
    else {
      variable1 = variable1.replace('leer entrada', 'Leer blog');
      // EXTRAER href
      const hrefMatch = variable1.match(/href="([^"]*)"/);

      const blogUrl = hrefMatch
        ? hrefMatch[1]
        : "";

      // LIMPIAR styles y links originales
      let cleanHtml = variable1
        .replace(/style="[^"]*"/g, "")
        .replace(/<a[^>]*>.*?<\/a>/gis, "");

      return (
        <>
          <div className="_ngcontent-ng-c485834739 _nghost-ng-c798911410">
            <div role="dialog" aria-modal="true" aria-labelledby="video-modal-title" class="video-modal">

              <section class="video-modal__panel">

                <button
                  type="button"
                  aria-label="Cerrar video"
                  onClick={() => {
                    closeModal();
                  }}
                  class="video-modal__close"
                >
                  ✕
                </button>

                <header class="video-modal__header">
                  <h2 id="video-modal-title" class="video-modal__title">
                    {variable3}
                  </h2>
                </header>

                <div
                  class="video-modal__body"
                  dangerouslySetInnerHTML={{ __html: cleanHtml }}
                >
                </div>

                <div className='div-compartir-idea-v'>

                  {/* SHARE */}

                  <span class="click-tooltip">
                    <span
                      tabIndex="0"
                      role="button"
                      className="click-tooltip__trigger"
                      aria-expanded={shareOpen}
                      ref={triggerRef}
                      onClick={() => setShareOpen(prev => !prev)}
                    >
                      <div class="post-actions__group post-actions__group--share library-btn-share">
                        <img
                          src="/assets/img2026/icon_share.svg"
                          alt="Compartir en redes"
                          aria-hidden="true"
                          class="post-actions__icon post-actions__icon--share"
                        />

                        <span class="post-actions__share-link">
                          {(t('2026.compartir'))}
                        </span>
                      </div>
                    </span>

                    {shareOpen && (
                      <span
                        className="click-tooltip__panel"
                        onClick={(e) => e.stopPropagation()}
                        ref={shareRef}
                      >
                        <span role="tooltip" class="up-arrow click-tooltip__content">
                          <span class="click-tooltip__actions">
                            <button
                              type="button"
                              aria-label="Compartir en X"
                              className="click-tooltip__action"
                              onClick={shareToX}
                            >
                              <img
                                src="/assets/img2026/logo_twitter.svg"
                                alt="Compartir en X"
                                className="click-tooltip__icon click-tooltip__icon--x"
                              />
                            </button>
                            <button
                              type="button"
                              aria-label="Compartir en Facebook"
                              className="click-tooltip__action"
                              onClick={shareToFacebook}
                            >
                              <img src="/assets/img2026/logo_facebook.svg" alt="Compartir en Facebook" class="click-tooltip__icon click-tooltip__icon--facebook" />
                            </button>
                            <button
                              type="button"
                              aria-label="Compartir por email"
                              className="click-tooltip__action"
                              onClick={shareByEmail}
                            >
                              <img src="/assets/img2026/icon_email.svg" alt="Compartir por email" aria-hidden="true" class="click-tooltip__icon click-tooltip__icon--email" />
                            </button>
                            <button
                              type="button"
                              aria-label="Compartir en Linkeding"
                              className="click-tooltip__action"
                              onClick={shareToLinkedin}
                            >
                              <img src="/assets/img2026/linkedin.svg" alt="Compartir en LinkedIn" class="click-tooltip__icon click-tooltip__icon--linkedin" />
                            </button>
                            <button
                              type="button"
                              aria-label="Copiar liga"
                              className="click-tooltip__action"
                              onClick={copyLink}
                            >
                              <img src="/assets/img2026/share.svg" alt="Copiar enlace" class="click-tooltip__icon click-tooltip__icon--share" />
                            </button>
                          </span>
                        </span>
                      </span>
                    )}

                  </span>

                  {/* BOTON BLOG */}

                  {blogUrl && (
                    <a
                      href={blogUrl}
                      className='btn_blog_id'
                    >
                      Blog
                    </a>
                  )}

                </div>

              </section>

            </div>
          </div>
          <ModalAlert
            isOpen={alertOpen}
            closeModal={() => setAlertOpen(false)}
            variable1={alertMessage}
          />
        </>
      );
    }
  }
};

export default Modal;